/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/solid'
import { Link } from 'react-router-dom'
import { getDefaultRoute } from '@utils/utils'
import { useSelector } from 'react-redux'
import { selectProfile } from '@redux/selectors/auth'

export default function Breadcurmb({ items }) {
  const profile = useSelector(selectProfile)
  const DefaultRoute = getDefaultRoute(profile)

  return (
    <nav className="flex mb-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-4 overflow-x-scroll sm:overflow-x-hidden">
        <li>
          <div>
            <Link to={DefaultRoute} className="text-gray-400 hover:text-gray-500">
              <HomeIcon className="flex-shrink-0 w-5 h-5" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </li>
        {items.map((item, idx) => (
          <li key={idx}>
            <div className="flex items-center">
              <ChevronRightIcon className="flex-shrink-0 w-5 h-5 text-gray-400" aria-hidden="true" />
              {(item.current) ?

                <div className="flex">
                  <p
                    className="ml-4 text-sm font-medium text-gray-500 whitespace-nowrap"                >
                    {item.name}
                  </p>
                  {item.render && item.render()}
                </div>
                :
                <Link
                  to={item.href}
                  className="ml-4 text-sm font-medium text-gray-500 underline hover:text-gray-700 whitespace-nowrap"
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Link>
              }
            </div>
          </li>
        ))}
      </ol>
    </nav>
  )
}
